// extracted by mini-css-extract-plugin
export default {"root":"aN95zg","toggle-button":"V3ix_B","toggleButton":"V3ix_B","icon":"H_wNsG"};